export default "__VITE_ASSET__CDeOoRgH__"